/** 타일은 정수 0..33 으로 인코딩한다.
 *  0-8   = 만(萬) 1-9
 *  9-17  = 통(筒) 1-9
 *  18-26 = 삭(索) 1-9
 *  27-33 = 자패 東南西北白發中 (표기 1z-7z)
 */
export type Tile = number;

export const NUM_TILE_TYPES = 34;

export function isMan(t: Tile): boolean { return t >= 0 && t <= 8; }
export function isPin(t: Tile): boolean { return t >= 9 && t <= 17; }
export function isSou(t: Tile): boolean { return t >= 18 && t <= 26; }
export function isHonor(t: Tile): boolean { return t >= 27 && t <= 33; }
export function isSuited(t: Tile): boolean { return t >= 0 && t <= 26; }

/** 수패의 1..9 숫자. 자패는 0. */
export function tileNumber(t: Tile): number {
  return isSuited(t) ? (t % 9) + 1 : 0;
}

/** 요구패: 1/9 수패 또는 모든 자패. */
export function isTerminalOrHonor(t: Tile): boolean {
  if (isHonor(t)) return true;
  const n = tileNumber(t);
  return n === 1 || n === 9;
}

/** 사람이 읽을 수 있는 표기. 예: 0→"1m", 27→"1z". */
export function tileName(t: Tile): string {
  if (isMan(t)) return `${t + 1}m`;
  if (isPin(t)) return `${t - 9 + 1}p`;
  if (isSou(t)) return `${t - 18 + 1}s`;
  return `${t - 27 + 1}z`;
}

/** "123m456p789s11z" 같은 표기를 타일 인덱스 배열로 파싱한다. */
export function parseTiles(s: string): Tile[] {
  const tiles: Tile[] = [];
  let digits: number[] = [];
  for (const ch of s) {
    if (ch >= '1' && ch <= '9') {
      digits.push(Number(ch));
      continue;
    }
    let base: number;
    if (ch === 'm') base = 0;
    else if (ch === 'p') base = 9;
    else if (ch === 's') base = 18;
    else if (ch === 'z') base = 27;
    else { digits = []; continue; } // 공백 등 무시
    for (const d of digits) tiles.push(base + (d - 1));
    digits = [];
  }
  return tiles;
}
